import React from "react";
import {
  Box,
  Heading,
  useColorMode,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Grid,
  Text,
  Flex,
} from "@chakra-ui/react";
import Translate from "../components/LanguageTranslation/Translate";

const FAQCreatorsPage = () => {
  const { colorMode } = useColorMode();

  return (
    <Box
      p={{ base: 8, md: 8, lg: 6, xl: 8 }}
      pl={{ base: 4, md: 8, lg: 20, xl: 48 }}
      pr={{ base: 4, md: 8, lg: 20, xl: 60 }}
      mt={{ base: 20, md: 0 }}
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        alignItems="right"
        w="100%"
      >
        <Box flex="2">
          <Heading
            as="h2"
            size={{ base: "30px", md: "xl", lg: "xl" }}
            fontFamily="Poppins, sans-serif"
            mb={4}
            ml={{ base: "4", md: "6", lg: "6", xl: "10" }}
            textAlign={{ base: "left", md: "left", lg: "left", xl: "left" }}
          >
            <Translate text="FAQs" />
          </Heading>
        </Box>
        <Box
          flex="2"
          justify="flex-end"
          align="right"
          w={{ base: "100%", md: "50%", lg: "50%", xl: "50%" }}
        >
          <Accordion
            allowToggle
            w={{ base: "100%", md: "100%", lg: "100%", xl: "80%" }}
            textAlign="left"
          >
            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="What is NOMAD360?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="NOMAD360 creates personalized travel plans in seconds,
              tailored to your outdoor lifestyle. Stress-free planning and
              epic adventures await!"
                />
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Who can use NOMAD360?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="NOMAD360 is an AI-powered travel planner designed for
              outdoor and adventure travelers. It creates personalized
              travel itineraries for hikers, campers, backpackers, families,
              digital nomads, photographers, wildlife enthusiast,
              overlanders, and much more."
                />
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Is NOMAD360 free to use?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate text="Yes, NOMAD360 is completely free! However, contributions are greatly appreciated to help maintain the platform and support our mission to a brighter, more sustainable future for all by offsetting CO2 emissions." />
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="How do I adjust my NOMAD360' itinerary?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text={`You can easily update your personalized NOMAD360 travel plans by clicking the edit icon in the Bucket List section. Additionally, when "Current Trip" is toggled on in the Bucket List, you can view and modify your plans directly from the current trip section.`}
                />
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Can I set a budget limit in NOMAD360 for my trip?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="Yes, NOMAD360 offers a comprehensive budget planner that
              allows you to set your financial preferences and supports
              multiple currencies. This tool helps you track your expenses
              while traveling, ensuring you stay on top of your spending."
                />
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Can I access NOMAD360 offline?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text="Yes, you can access NOMAD360 offline! By downloading your
              itinerary and essential information before your trip, you'll
              be well-prepared for areas without internet connectivity. This
              allows you to enjoy your adventure worry-free, even when
              you're off the grid."
                />
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton
                p={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
                _hover="none"
                fontWeight="bold"
              >
                <Box flex="1" textAlign="left">
                  <Translate text="Where can I receive support for using NOMAD360?" />
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                pb={4}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                <Translate
                  text={`If you have any specific questions or comments, go to "Report a Problem" in your account and submit your issue. Our team will get back to you as
                                                               soon as possible. We’re here to help you make the most of your
                                                               travel experience!`}
                />
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Flex>
    </Box>
  );
};

export default FAQCreatorsPage;
